import { CSSProperties } from 'react';

import styled from 'styled-components';

import { token } from '@atlaskit/tokens';

import { StateProps } from '../types';

const gridSize = token('space.100', '8px');

export const Wrapper = styled.div`
  display: flex;

  & > div {
    margin-right: ${token('space.100', '8px')};
  }
`;

export const SearchFieldWrapper = styled.div`
  width: calc(${gridSize} * 20px);

  button {
    height: auto;
  }
`;

export const SearchIconWrapper = styled.div`
  display: flex;
  margin-right: ${token('space.075', '6px')};
`;

export const ButtonWrapper = styled.div`
  margin-right: ${token('space.075', '6px')};
`;

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
export const UsersFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-right: ${token('space.200', '16px')};
  position: relative;
  min-width: calc(${gridSize} * 18.5px);

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    height: ${token('space.200', '16px')};
    transform: translateY(-50%);
    width: 1px;
    right: 0;
    background: rgb(223, 225, 230);
  }
`;

export const subtleSelector = (css: CSSProperties, state: StateProps) => ({
  backgroundColor: state.isFocused ? css.backgroundColor : 'transparent',
  borderColor: state.isFocused ? css.borderColor : 'transparent',
});

export const BranchesListWrapper = styled.div`
  margin-left: ${token('space.100', '8px')};
  min-width: 180px;
`;

export const BranchItem = styled.div`
  display: flex;
  align-items: center;
`;

export const BranchName = styled.div`
  flex: 1;
  margin-left: ${token('space.050', '4px')};
`;
